import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import { Provider } from "react-redux";
import store from "./app/store"
import { initAuthTokenFromUrl } from "./helpers/initAuthTokenFromUrl";

initAuthTokenFromUrl();

const root = ReactDOM.createRoot(
  document.getElementById('root'));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);


